module.exports = __webpack_public_path__ + "static/media/m_w_hr_45.4bd92f43.png";